import { render, staticRenderFns } from "./MapCategoriesList.vue?vue&type=template&id=4e52a9b9&scoped=true"
import script from "./MapCategoriesList.vue?vue&type=script&lang=js"
export * from "./MapCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./MapCategoriesList.vue?vue&type=style&index=0&id=4e52a9b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52a9b9",
  null
  
)

export default component.exports